import { Grid } from "@material-ui/core";
import React from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import { Colors } from "../../../theme/colors";
import { StyledInput } from "../../form/input";
import {CountryModel} from "../../../models/country.model";
import {StyledSelect} from "../../form/select";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/root-reducer";
import {CountryAutocomplete} from "../../form/country-autocomplete";

export const EditProfileFormStep3: React.FC<Props> =
    ({
        handleChange,
        setFieldValue,
        values,
        errors,
        touched
    }) => {
        const { t } = useTranslation(['publisher', 'common']);

        return <>
            <Grid container direction="column" alignContent="center">
				<StyledTitle>{t('editProfile.step3Title')}</StyledTitle>
				<Grid item container direction="column" sm={12} md={6} spacing={2}>
					<Grid item sm={12}>
						<StyledInput
							id="address"
							label={t('editProfile.form.address')}
							onChange={handleChange}
							value={values.address}
						/>
					</Grid>

					<Grid item sm={12}>
						<StyledInput
							id="postalCode"
							label={t('editProfile.form.postalCode')}
							onChange={handleChange}
							value={values.postalCode}
						/>
					</Grid>

					<Grid item sm={12}>
						<StyledInput
							id="city"
							label={t('editProfile.form.city')}
							onChange={handleChange}
							value={values.city}
						/>
					</Grid>
				</Grid>
			</Grid>
        </>;
    }

interface Props {
    handleChange: any;
    setFieldValue: any;
    values: any;
    errors: any;
    touched: any;
}

const StyledTitle = styled('p')`
  color: ${Colors.lightViolet};
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;
